import { Box, Stack } from "@mui/material";
import { useIsJobsEnabled } from "@src/appV2/redesign/PlacementCandidate/useIsJobsEnabled";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface RestrictionConsequencesCardProps {
  restrictionDurationDays: number | undefined;
}

interface ConsequenceItemProps {
  number: number;
  text: string;
}

function ConsequenceItem(props: ConsequenceItemProps): JSX.Element {
  const { number, text } = props;

  return (
    <Stack direction="row" spacing={4} alignItems="center">
      <Box
        sx={(theme) => ({
          minWidth: 28,
          height: 28,
          borderRadius: "50%",
          backgroundColor: theme.palette.background?.secondary,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <Text semibold variant="body2">
          {number}
        </Text>
      </Box>
      <Text variant="body2">{text}</Text>
    </Stack>
  );
}

export function RestrictionConsequencesCard(props: RestrictionConsequencesCardProps): JSX.Element {
  const { restrictionDurationDays } = props;
  const isJobsEnabled = useIsJobsEnabled();
  const durationLabel = restrictionDurationDays ?? 7;

  return (
    <Stack
      spacing={5}
      sx={(theme) => ({
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        borderRadius: theme.shape.borderRadius,
        padding: 6,
        boxShadow: theme.shadows[1],
      })}
    >
      <Text semibold variant="body1" sx={(theme) => ({ color: theme.palette.intent?.error?.text })}>
        Your account will:
      </Text>

      <Stack spacing={4}>
        <ConsequenceItem number={1} text="Be removed from all future shifts" />
        <ConsequenceItem number={2} text={`Unable to book new shifts for ${durationLabel}d.`} />
        {isJobsEnabled && (
          <ConsequenceItem number={3} text="Retain access to Clipboard Jobs and Shift Invites." />
        )}
      </Stack>
    </Stack>
  );
}
